export default __webpack_public_path__ + "static/media/Img_battery_accessories.6cf61aa0.svg";